import { defineStore } from 'pinia';
import { PAYMENTS_REQUEST_INTERVAL } from '~/utils/constants';
import { softswiss } from '../transport/softswiss';
import type { ISsPlayerPayments } from '~/types/softswiss/ssPlayerPayments';

export const useStoreSsPlayerPayments = defineStore('ssPlayerPayments', {
  state: () => ({
    payments: [] as ISsPlayerPayments[],
    lastUpdateTime: NaN,
    intervalId: NaN,
    requestPromise: null as Promise<any> | null,
  }),
  getters: {
    deposits(): ISsPlayerPayments[] {
      return this.payments.filter((p) => p.action === 'deposit');
    },
    cashouts(): ISsPlayerPayments[] {
      return this.payments.filter((p) => p.action === 'cashout');
    },
  },

  actions: {
    fetchData(path: string) {
      if (!this.requestPromise) {
        this.requestPromise = softswiss()
          .get({ path, cacheble: false, force: true })
          .finally(() => (this.requestPromise = null));
      }

      return this.requestPromise;
    },
    async load() {
      const request: ISsPlayerPayments[] = await this.fetchData('/api/player/payments');

      if (request) {
        this.payments = request;
        this.lastUpdateTime = Date.now();
        return true;
      } else {
        return false;
      }
    },

    /* 
      WARNING: this should not be used at the moment due to the problems with 
      SS API
    */
    async recall(transactionId: number) {
      const request = await this.fetchData(`/api/player/payments/${transactionId}/recall`);

      if (request) {
        this.payments = request;
        this.lastUpdateTime = Date.now();
        return true;
      } else {
        return false;
      }
    },

    addPayment(payment: ISsPlayerPayments) {
      if (this.payments.find((p) => p.id === payment.id)) {
        return;
      }

      this.payments.push(payment);
      this.lastUpdateTime = Date.now();
    },

    async startCheckingUpdates() {
      await this.load();
      this.intervalId = window.setInterval(() => {
        if (Date.now() - this.lastUpdateTime > PAYMENTS_REQUEST_INTERVAL) {
          this.load();
        }
      }, PAYMENTS_REQUEST_INTERVAL);
    },

    stopCheckingUpdates() {
      window.clearInterval(this.intervalId);
      this.$reset();
    },
  },
});
